import InvestmentTaxDeclaration from './investmentTaxDeclaration';
export default InvestmentTaxDeclaration;